import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    type: String,
    url: String,
    posterUrl: String,
    comment: String,
    photoDuration: Number,
    videoDuration: Number
  }

  connect() {
    if (!this.urlValue) return

    document.dispatchEvent(new CustomEvent("stream:incoming", {
      detail: {
        type: this.typeValue,
        url: this.urlValue,
        poster_url: this.posterUrlValue || null,
        comment: this.commentValue || null,
        photo_duration: this.photoDurationValue,
        video_duration: this.videoDurationValue,
        immediate: true
      }
    }))
  }
}
